// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EM4Y","colMin":"styles_colMin__3ziVC"};